// Module
var code = `<div class="match-score"> {{matchScoreCtrl.formattedMatchScore}} </div>`;
// Exports
export default code;